import { Box, Button, FlexBox, Icon, Typography } from '@vp/swan';

export interface BriefReadyCardProps {
    onReview: () => void;
    onContinue?: () => void;
}

export function BriefReadyCard({ onReview, onContinue }: BriefReadyCardProps) {
    return (
        <Box
            style={{
                backgroundColor: 'var(--swan-sem-color-bg-active)',
                border: '1px solid var(--swan-sem-color-border-standard)',
                borderBottom: 'none',
                padding: 'var(--swan-sem-space-6)',
                borderRadius:
                    'var(--swan-sem-border-radius-standard) var(--swan-sem-border-radius-standard) 0 0',
            }}
        >
            {/* Header with icon */}
            <FlexBox alignItems="center" gap={3} mb={5}>
                <Icon iconType="polish" size="standard" skin="accent" />
                <Typography fontSkin="title-item">Your brief is ready!</Typography>
            </FlexBox>
            {/* Process steps */}
            <Box as="ul" style={{ margin: 0, paddingLeft: 'var(--swan-sem-space-5)' }}>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    Your designer will review your brief and begin working on your design
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    You'll receive your first draft within 24 hours
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={5}>
                    You can provide feedback over 3 rounds of revisions
                </Typography>
            </Box>

            <FlexBox gap={4} alignItems="center">
                {/* Review button */}
                <Button skin="primary" iconPosition="left" onClick={onReview}>
                    <Icon iconType="edit" size="small" />
                    Review your brief
                </Button>
                {onContinue && (
                    <Button skin="tertiary" iconPosition="left" onClick={onContinue}>
                        <Icon iconType="aiSupport" size="small" />
                        Continue chat
                    </Button>
                )}
            </FlexBox>
        </Box>
    );
}
